export default {
    SHIPPING_ADDRESS_TYPE: "shipping",
    BILLING_ADDRESS_TYPE: 'billing'
}



// WEBPACK FOOTER //
// ./src/view/constant/checkout/quote/AddressConstant.js